export default __webpack_public_path__ + "media/images/dog-photo-ea6b7fdd08424fb65266f6d69f49ab91.jpg";